import CheckBox from "../common_input/CheckBox";

/*LIBRARY*/
import { useState, useEffect, useRef, useCallback } from "react";
import { connect } from "react-redux";
import { FiberManualRecord, InfoOutlined } from "@material-ui/icons";
import { Box, Typography } from "@mui/material";

/*COMPONENT*/
import PricingCard from "./PricingCard";
import Modal from "../common_modal/Modal";

/*REDUX*/
import {
  get_price_2025,
  calculate_price,
  ever_purchased_license,
} from "../../App/actions/paymentActions";
import { set_value_user } from "../../App/actions/authActions";

/*PICTURE*/

/*FUNCTION*/
import history from "../../App/actions/history";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/
const all_included_licenses = [
  "license_basic",
  "license_sini_ai",
  "license_sini_data",
];

const PaymentTable = ({
  auth,
  trial_objects,
  package_selected,
  set_package_selected,
  set_page,
  get_price_2025: get_price_2025_action,
  calculate_price: calculate_price_action,
  set_value_user: set_value_user_action,
  ever_purchased_license: ever_purchased_license_action,
}) => {
  const [personal, set_personal] = useState({
    price: 0,
    no_discount: 0,
    month: 12,
    licenses: ["license_basic"],
  });

  const [team, set_team] = useState({
    price: 0,
    no_discount: 0,
    month: 12,
    collaborators: 1,
    licenses: all_included_licenses,
  });

  const [modal_banner_trial, set_modal_banner_trial] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [is_first_open, set_is_first_open] = useState(true);
  const [is_ever_purchase, set_is_ever_purchase] = useState(false);

  const personalRef = useRef(personal);
  const teamRef = useRef(team);
  const packageSelectedRef = useRef(package_selected);
  const authRef = useRef(auth);

  useEffect(() => {
    personalRef.current = personal;
  }, [personal]);

  useEffect(() => {
    teamRef.current = team;
  }, [team]);

  useEffect(() => {
    packageSelectedRef.current = package_selected;
  }, [package_selected]);

  useEffect(() => {
    authRef.current = auth;
  }, [auth]);

  const toggle_modal_banner_trial = () => {
    set_modal_banner_trial((prev) => !prev);
  };

  const do_calculate_price = useCallback(
    async (package_name, override_state) => {
      const new_package_name = package_name || packageSelectedRef.current;
      const selected_package =
        override_state ||
        (new_package_name === "personal"
          ? personalRef.current
          : teamRef.current);
      const current_currency =
        (authRef.current?.user?.country || "Indonesia") === "Indonesia"
          ? "IDR"
          : "USD";

      const res_calculation = await calculate_price_action({
        package_type: new_package_name,
        currency: current_currency,
        license_includes: selected_package?.licenses?.map((license) => ({
          license_key: license,
          month: selected_package?.month,
        })),
        collaborators: (selected_package?.collaborators || 0) + 1,
      });

      if (!res_calculation) return;

      const updated_fields = {
        price: res_calculation.showed_price,
        no_discount: res_calculation.showed_price_without_discount,
      };

      if (new_package_name === "personal") {
        set_personal((prev) => ({ ...prev, ...updated_fields }));
      } else {
        set_team((prev) => ({ ...prev, ...updated_fields }));
      }

      set_is_ever_purchase(res_calculation.is_ever_purchased_license);

      set_is_first_open((prev_first_open) => {
        if (prev_first_open) {
          set_modal_banner_trial(!res_calculation.is_ever_purchased_license);
          return false;
        }
        return prev_first_open;
      });
    },
    [calculate_price_action],
  );

  const hasInitialized = useRef(false);

  useEffect(() => {
    if (hasInitialized.current) return;
    hasInitialized.current = true;

    const init = async () => {
      const params = new URLSearchParams(window.location.search);
      const payment_type = params.get("payment_type");
      const collaborators = +params.get("collaborators") || 2;
      const month = +params.get("month") || 1;
      let license_key = params.get("license");

      const res = await ever_purchased_license_action();
      const is_ever_purchased = res?.is_ever_purchased_license || false;

      let initial_personal = personalRef.current;
      let initial_team = teamRef.current;

      if (payment_type === "personal") {
        const license_suggestion = "license_basic";
        if (
          !is_ever_purchased &&
          license_key !== license_suggestion &&
          payment_type === "personal"
        ) {
          license_key = license_suggestion;
        }

        set_package_selected(payment_type);
        let licenses = [];
        let is_done = false;
        if (all_included_licenses.includes(license_key)) {
          all_included_licenses.forEach((item) => {
            if (!is_done) {
              licenses.push(item);
              if (item === license_key) is_done = true;
            }
          });
        }

        initial_personal = {
          ...initial_personal,
          licenses,
          month,
          is_ever_purchased_license: is_ever_purchased,
        };
        set_personal(initial_personal);
      } else if (payment_type === "team") {
        set_package_selected(payment_type);
        initial_team = {
          ...initial_team,
          month,
          collaborators,
          is_ever_purchased_license: is_ever_purchased,
        };
        set_team(initial_team);
      }

      get_price_2025_action();

      await do_calculate_price("personal", initial_personal);
      await do_calculate_price("team", initial_team);
    };

    init();
  }, [
    do_calculate_price,
    ever_purchased_license_action,
    get_price_2025_action,
    set_package_selected,
  ]);

  const isFirstRender = useRef(true);

  const personal_month = personal.month;
  const personal_licenses_str = JSON.stringify(personal.licenses);
  const team_month = team.month;
  const team_licenses_str = JSON.stringify(team.licenses);
  const team_collaborators = team.collaborators;

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    // Calculate both packages explicitly so prices update on touch screens
    do_calculate_price("personal");
    do_calculate_price("team");
  }, [
    personal_month,
    personal_licenses_str,
    team_month,
    team_licenses_str,
    team_collaborators,
    do_calculate_price,
  ]);
  const toggleBuyNow = (override_package, override_state) => {
    const current_package = override_package || package_selected;
    const current_state =
      override_state || (current_package === "personal" ? personal : team);

    if (set_page && auth?.isAuthenticated) {
      set_page({
        package_object: {
          ...current_state,
          package_type: current_package,
        },
        new_page: "payment_method",
      });
    } else {
      set_value_user_action("modal_payment_universal", false);
      if (!window.location.search) {
        const params = new URLSearchParams();
        const { licenses, month, collaborators } = current_state;
        const last_license = licenses?.at(-1);

        if (current_package) params.set("payment_type", current_package);
        if (licenses?.length > 0) params.set("license", last_license);
        if ([1, 12].includes(month)) params.set("month", month);
        if (collaborators >= 2 && collaborators <= 10)
          params.set("collaborators", collaborators);

        history.push(`/register?${params.toString()}`);
      } else {
        history.push(`/register${window.location.search}`);
      }
    }
  };

  const handleLicenseChecklist = (index) => {
    const current_licenses_length = personal.licenses?.length || 0;

    let new_index = +index;
    if (new_index + 1 <= current_licenses_length) {
      new_index = index - 1;
    }

    let lic = [];
    for (let idx = 0; idx <= new_index; idx++) {
      lic.push(all_included_licenses[idx]);
    }

    set_personal((prev) => ({
      ...prev,
      licenses: lic,
    }));
  };

  const handle_collaborators = (operator) => {
    set_team((prev) => {
      const current = prev.collaborators || 1;
      let value = current;
      if (operator === "+" && value < 10) {
        value = current + 1;
      } else if (operator === "-" && value >= 2) {
        value = current - 1;
      }
      return { ...prev, collaborators: value };
    });
  };

  //local storage
  const language = localStorage?.language ? localStorage?.language : "ina";

  //local state

  //global props

  const currency =
    (auth?.user?.country || "Indonesia") === "Indonesia" ? "IDR" : "USD";

  let free_trial_text = "";
  if (!is_ever_purchase && personal?.month === 1) {
    free_trial_text = (
      <Box
        sx={{
          display: "flex",
          alignItems: "center", // Vertically centers the items
          justifyContent: "start", // Horizontally centers the items
          height: "15px", // Example fixed height for the container
        }}
      >
        <Typography variant="body1" fontSize={12}>
          {dict["1 Month Free Access to SINI AI & SINI DATA"][language]}
        </Typography>
        <div
          className="tooltip"
          data-tooltip={dict["New Users Only"][language]}
        >
          <InfoOutlined
            style={{ marginLeft: "2px", fontSize: "16px", color: "black" }}
          />
        </div>
      </Box>
    );
  } else if (personal?.month === 12) {
    const style_box = {
      display: "flex",
      alignItems: "center", // Vertically centers the items
      justifyContent: "start", // Horizontally centers the items
      minHeight: "15px", // Example fixed height for the container
    };
    free_trial_text = (
      <div>
        <Box sx={style_box}>
          <FiberManualRecord style={{ marginRight: "5px", fontSize: "5px" }} />
          <Typography variant="body1" fontSize={12}>
            {dict["Annual plan – save 2 months of fees"][language]}
          </Typography>
          <div
            className="tooltip"
            data-tooltip={
              dict[
                "With the annual plan, you pay for a full year upfront and save the equivalent of 2 months compared to monthly billing."
              ][language]
            }
          >
            <InfoOutlined
              style={{ marginLeft: "5px", fontSize: "16px", color: "black" }}
            />
          </div>
        </Box>

        {personal?.licenses?.length - 1 < 1 && !is_ever_purchase && (
          <Box sx={style_box}>
            <FiberManualRecord
              style={{ marginRight: "5px", fontSize: "5px" }}
            />
            <Typography variant="body1" fontSize={12}>
              {dict["1 Month Free Access to SINI AI & SINI DATA"][language]}
            </Typography>
            <div
              className="tooltip"
              data-tooltip={dict["New Users Only"][language]}
            >
              <InfoOutlined
                style={{ marginLeft: "5px", fontSize: "16px", color: "black" }}
              />
            </div>
          </Box>
        )}
      </div>
    );
  }

  //content
  const all_plans = [
    {
      package_type: "personal",
      title: "Personal",
      subtitle: dict["Best for personal use"][language],
      price: personal?.price,
      no_discount:
        personal?.price !== personal?.no_discount
          ? personal?.no_discount
          : null,
      free_trial: free_trial_text,
      unit: "Month",
      currency,
      settings: [
        {
          type: "slider",
          value: personal?.licenses?.length - 1,
          labels: [
            {
              value: 1,
              label: "SINI AI",
            },
            {
              value: 2,
              label: "SINI DATA",
            },
          ],
          onChange: handleLicenseChecklist,
        },
      ],
      included_licenses: personal?.licenses || [],
      // We pass down month so AddonFeatureChecklist inside the card still works
      duration: {
        month: personal?.month,
      },
      button: {
        text: dict["Choose"][language],
        onSubmit: () => toggleBuyNow("personal"), // Add "personal"
      },
      is_active: package_selected === "personal",
    },
    {
      package_type: "team",
      subtitle: dict["Best for small company"][language],
      title: "Team",
      settings: [
        {
          header: dict["Collaboration"][language],
          type: "counter",
          value: team?.collaborators,
          unit: dict["collaborators"][language],
          onChange: handle_collaborators,
        },
      ],
      price: team?.price,
      no_discount: team?.price !== team?.no_discount ? team?.no_discount : null,
      unit: "User",
      currency,
      included_licenses: [
        "license_basic",
        "license_sini_ai",
        "license_sini_data",
      ],
      duration: {
        month: team?.month,
      },
      button: {
        text: dict["Choose"][language],
        onSubmit: () => toggleBuyNow("team"), // Add "team"
      },
      is_active: package_selected === "team",
    },
    {
      package_type: "enterprise",
      title: "Enterprise",
      subtitle: dict["Contact us for tailored solution"][language],
      // extra_title: "",
      included_licenses: [
        "license_basic",
        "license_sini_ai",
        "license_sini_data",
      ],
      notes: {
        header: "Advanced Enterprise Features",
        body: dict["Every enterprise has unique needs and objectives."][
          language
        ],
        footer:
          dict["We can tailor special features and plans specifically for you"][
            language
          ],
      },
      button: {
        text: dict["Contact us"][language],
        onSubmit: () => {
          const phone = "6281330881510";
          const url = `https://api.whatsapp.com/send?phone=${phone}`;
          window.open(url, "_blank");
        },
      },
      is_active: package_selected === "enterprise",
    },
  ];

  const prices_render = all_plans.map((plan, idx) => (
    <PricingCard
      key={idx}
      {...plan}
      set_package_selected={set_package_selected}
      is_ever_purchase={is_ever_purchase}
    />
  ));

  const modal_banner_trial_content = modal_banner_trial && (
    <Modal
      modalSize="small"
      id="modal_pricing"
      isOpen={modal_banner_trial}
      onClose={toggle_modal_banner_trial}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <p className="text_big margin_bottom text_center margin_bottom">
          {dict["You Get a First Purchase Bonus!"][language]}
        </p>

        <div className="sini_container_animation margin_bottom_extra">
          <div className="sini_shape_animation sini_circle_1"></div>
          <div className="sini_shape_animation sini_circle_2"></div>
          <div className="sini_shape_animation sini_circle_3"></div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "50px",
          }}
        >
          <div style={{ display: "flex", gap: "20px" }}>
            {trial_objects.map((trial, trial_idx) => (
              <div
                key={trial_idx}
                style={{ display: "flex", flexDirection: "column" }}
              >
                <label className="text_big">{trial?.name?.[language]}</label>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  {trial?.subfeatures.map((feature, feature_idx) => (
                    <label className="text_medium" key={feature_idx}>
                      - {feature?.[language]}
                    </label>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        <button
          onClick={() => {
            set_package_selected("personal");
            const updated_personal = {
              ...personal,
              month: 1,
              licenses: ["license_basic"],
            };
            set_personal(updated_personal);
            toggleBuyNow("personal", updated_personal);
          }}
          className="button_big background_black text_white"
        >
          {dict["Claim Now!"][language]}
        </button>
      </div>
    </Modal>
  );

  return (
    <main>
      {/* GLOBAL CENTERED TOGGLE */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: "30px",
        }}
      >
        <CheckBox
          text="billing_cycle"
          left_title={<span className="text_medium">Monthly</span>}
          title={
            <>
              <span className="text_medium margin_right">Annual</span>
              <span className="badge_small blue_container">Save!</span>
            </>
          }
          value={personal.month === 12}
          handle={() => {
            const new_month = personal.month === 12 ? 1 : 12;
            set_personal((prev) => ({ ...prev, month: new_month }));
            set_team((prev) => ({ ...prev, month: new_month }));
          }}
        />
      </div>

      <div
        style={{
          width: "100%",
          overflowX: "auto",
        }}
      >
        <div className="adaptive_justify">
          <div
            style={{
              display: "flex",
              gap: "20px",
              minWidth: "max-content",
            }}
          >
            {prices_render}
          </div>
        </div>
      </div>
      {modal_banner_trial_content}
      {/* {modal_buy_now_content} */}
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  trial_objects: state.payment?.license_features_2025?.filter((item) =>
    all_included_licenses.slice(1).includes(item.key),
  ),
});

export default connect(mapStateToProps, {
  get_price_2025,
  calculate_price,
  set_value_user,
  ever_purchased_license,
})(PaymentTable);
